import React, { useState } from "react";

import ProjectsCard from "./ProjectsCard";
import "./ProjectsOnlineMode.scss";

import LoginInDialog from "../Login/LoginInDialog";
import Axios from "middleware/axiosInstance";

export const ProjectsOnlineMode = () => {
  // check if authentication is expired
  const [authenticationIsExpired, setAuthenticationIsExpired] = useState(false);

  const [searchPojectsName, setSearchProjectsName] = useState([]);

  const searchProject = async (e) => {
    if (!navigator.onLine) {
      alert("به اینترنت متصل نمی باشید");
    } else if (e.target.value.length > 2) {
      try {
        await Axios.get(`projects?employer=${e.target.value}`)
          .then((response) => {
            setSearchProjectsName(response.data.data.reverse());
          })
          .catch(() => {
            alert("جستجوی پروژه ناموفق!");
          });
      } catch {
        alert("ارتباط با سرور برقرار نشد!");
      }
    } else {
      const apiRoute = `user/leaves?api_token=${localStorage.getItem("token")}`;
      Axios.get(apiRoute)
        .then()
        .catch((error) => {
          try {
            error.response.status === 401
              ? setAuthenticationIsExpired(true)
              : alert("عملیات انجام نشد!");
          } catch {
            alert("ارتباط با سرور برقرار نشد!");
          }
        });
      setSearchProjectsName([]);
    }
  };

  return (
    <div className="main-container-With-tabbar d-flex align-items-center flex-column">
      <form className="search-projects-form" noValidate autoComplete="off">
        <p>نام کارفرما:</p>
        <input
          className="search-projects-input"
          type="text"
          onKeyUp={searchProject}
        />
      </form>
      <div className="search-projects-results">
        {searchPojectsName.map((project, index) => {
          return (
            <ProjectsCard project={project} offlineMode={false} key={index} />
          );
        })}
      </div>

      {authenticationIsExpired && <LoginInDialog />}
    </div>
  );
};
export default ProjectsOnlineMode;
